import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      title: 'New Project',
      description: 'Start creating film credits',
      icon: 'Plus',
      variant: 'default',
      action: () => navigate('/credit-creation')
    },
    {
      title: 'Excel Template',
      description: 'Download credit template',
      icon: 'Download',
      variant: 'outline',
      action: () => {
        // Mock download action
        const link = document.createElement('a');
        link.href = '/assets/templates/film-credits-template.xlsx';
        link.download = 'film-credits-template.xlsx';
        link?.click();
      }
    },
    {
      title: 'Style Library',
      description: 'Browse credit templates',
      icon: 'Palette',
      variant: 'outline',
      action: () => navigate('/project-management')
    },
    {
      title: 'Render Queue',
      description: 'Check video status',
      icon: 'Play',
      variant: 'outline',
      action: () => navigate('/video-rendering')
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <h3 className="font-semibold text-foreground mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {quickActions?.map((action, index) => (
          <Button
            key={index}
            variant={action?.variant}
            iconName={action?.icon}
            iconPosition="left"
            onClick={action?.action}
            className="justify-start h-auto p-3 flex-col items-start space-y-1"
          >
            <div className="flex items-center space-x-2 w-full">
              <span className="font-medium text-sm">{action?.title}</span>
            </div>
            <span className="text-xs text-muted-foreground text-left">
              {action?.description}
            </span>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;